<template>
  <div id="app" @touchstart="handleTouchStart" @touchend="handleTouchEnd">
    <!-- 隐藏的地图容器（TMap所需） -->
    <div id="map-container" style="display: none;"></div>
    
    <!-- 锁定层 -->
    <div v-if="locationBlocked" class="location-blocker">
      <div class="blocker-content">
        <i class="el-icon-warning-outline"></i>
        <p>{{ locationError || '处理中...' }}</p><!--当前定位不能使用本APP-->
        <el-button 
          v-if="showRetryButton" 
          type="primary" 
          @click="retryLocation"
          :loading="isRetrying"
        >
          重试定位
        </el-button>
      </div>
      <!-- <div class="blocker-overlay" v-if="userLocation">坐标：{{userLocation || userLocation.lat || ''}},{{userLocation || userLocation.lng || ''}}</div> -->
    </div>
    
    <!-- 加载状态 -->
    <div v-if="mapLoading" class="location-loading">
      <div class="loading-content">
        <i class="el-icon-loading"></i>
        <p>正在获取定位信息...</p>
      </div>
    </div>
    
    <!-- 正常内容 -->
    <div v-else-if="!locationBlocked">
      <router-view/>
      <el-menu 
        :default-active="activeIndex" 
        class="el-menu-demo" 
        mode="horizontal" 
        @select="handleSelect" 
        :class="{ 'hide': isHome }"
      >
        <el-menu-item index="1">
          <router-link to="/student"><i class="hxfont">&#xe792;</i>首页</router-link>
        </el-menu-item>
        <el-menu-item index="2">
          <router-link to="/table"><i class="hxfont">&#xe607;</i>立即测评</router-link>
        </el-menu-item>
        <el-menu-item index="3">
          <router-link to="/home"><i class="hxfont">&#xe941;</i>我的测评</router-link>
        </el-menu-item>
      </el-menu>
    </div>
  </div>
</template>

<script>
import useAppStore from './stores/modules/app'

export default {
  name: 'App',
  data() {
    return {
      activeIndex: '1',
      touchStartX: 0,
      touchEndX: 0,
      touchStartY: 0,
      touchEndY: 0,
      appStore: null,
      allowedLocation: null,   // 允许的坐标 { lat, lng, useScope }
      userLocation: null,      // 用户当前坐标
      locationBlocked: true,  // 默认锁定
      locationError: null,     // 错误信息
      tMapLoaded: false,       // TMap是否加载完成
      mapLoading: false,       // 地图加载状态
      currentLocationMethod: null, // 当前使用的定位方式
      isRetrying: false,       // 是否正在重试
      showRetryButton: false,  // 是否显示重试按钮
      locationCache: null,     // 定位缓存
      cacheExpiry: 10 * 60 * 1000, // 缓存有效期10分钟
      deptId:0
    }
  },
  mounted() {
    // console.log('====',this.$route.query.dp,this.$router.currentRoute);
    // let a = new useAppStore();
    this.deptId = this.appStore.getDpId() || this.$route.query.dp;
    if(this.$route.query.dp && this.$route.query.dp != this.appStore.getDpId()){
      this.deptId = this.$route.query.dp;
    }
    if(!this.deptId){
      this.locationBlocked = true;
      this.locationError = "系统入口参数缺失，请联系管理员！";
    }else{
      console.log('===this.appStore.deptId=app.vue==',this.deptId);
      this.appStore.setDpId(this.deptId);
      //关闭定位在这
      this.locationBlocked = false;
      //this.initLocationService();
    }
    
    //new Error('智能硬件定位失败: ' + '未知错误');
  },
  methods: {
    // 初始化定位服务
    async initLocationService() {
      this.mapLoading = true;
      
      try {
        // 获取配置
        await this.appStore.getConfig().then(data => {
          this.setFavicon(data.web_favicon);
          if (data.allowed_location) {
            this.allowedLocation = data.allowed_location;
          }else{
            this.locationError = '系统初始化失败: ' + (error.message || '接口错误');
            this.locationBlocked = true;
            this.showRetryButton = true;
          }
        });
        
        // 检查用户位置  本地调试时注释掉 ==================================================================================
        await this.checkUserLocation();
        // 打开这个注释，用于调试定位问题 开启定位时，注释掉这个行，关闭定位时，打开这行，注掉前一行
        //this.locationBlocked = false
      } catch (error) {
        console.error('初始化失败:', error);
        this.locationError = '系统初始化失败: ' + (error.message || '未知错误');
        this.locationBlocked = true;
        this.showRetryButton = true;
      } finally {
        this.mapLoading = false;
      }
    },
    
    // 初始化新版 TMap（仅用于地图展示）
    initTMap() {
      return new Promise((resolve, reject) => {
        if (window.TMap && window.TMap.Map) {
          this.tMapLoaded = true;
          resolve();
          return;
        }

        if (document.getElementById('tmap-script')) {
          window.initTMapCallback = () => {
            this.tMapLoaded = true;
            resolve();
          };
          return;
        }

        const script = document.createElement('script');
        script.id = 'tmap-script';
        script.src = `https://map.qq.com/api/gljs?v=2.exp&key=ELFBZ-JDME2-Y74UU-CQZNV-UXLI6-PVBRC`;
        script.onerror = () => reject(new Error('TMap加载失败'));
        
        window.initTMapCallback = () => {
          this.tMapLoaded = true;
          resolve();
        };

        document.head.appendChild(script);
      });
    },

    // 检查用户位置（主入口）
    async checkUserLocation() {
      // 检查缓存
      if (this.checkLocationCache()) {
        this.validateLocation(this.locationCache);
        return;
      }
      
      // 按优先级尝试各种定位方式
      try {
        // 1. 优先尝试HTML5定位
        this.currentLocationMethod = 'HTML5';
        const position = await this.getHTML5Location();
        this.handleLocationSuccess(position);
      } catch (html5Error) {
        console.warn('定位失败:', html5Error);
        this.locationError = '定位失败:' + html5Error || '定位失败: 未知错误';
        this.locationBlocked = true;
        /* try {
          // 2. 尝试通过后端代理调用腾讯位置服务的智能硬件定位接口
          this.currentLocationMethod = 'TencentHardware';
          const position = await this.getTencentHardwareLocation();
          this.handleLocationSuccess(position, true); // 标记为低精度
        } catch (tencentError) {
          console.warn('腾讯硬件定位失败:', tencentError);
          
          try {
            // 3. 最后尝试IP定位作为备用
            this.currentLocationMethod = 'IP';
            const position = await this.getIPLocation();
            this.handleLocationSuccess(position, true); // 标记为低精度
          } catch (ipError) {
            console.error('所有定位方式均失败:', ipError);
            this.handleLocationFailure(ipError);
          }
        } */
      }
    },
    
    // 处理定位成功
    handleLocationSuccess(position, isLowAccuracy = false) {
      this.userLocation = {
        lat: position.lat,
        lng: position.lng,
        accuracy: position.accuracy || (isLowAccuracy ? 5000 : 100), // IP定位默认5km精度
        method: this.currentLocationMethod
      };
      
      // 保存到缓存
      this.saveLocationToCache(this.userLocation, isLowAccuracy ? 5 * 60 * 1000 : null);
      
      // 验证位置
      this.validateLocation(this.userLocation);
      
      // 如果使用IP定位且精度不足，显示提示
      if (isLowAccuracy) {
        this.locationError = '当前使用低精度定位，精度较低，请开启GPS获取更准确位置';
        this.showRetryButton = true;
      }
    },
    
    // 处理定位失败
    handleLocationFailure(error) {
      this.locationError = this.getGeolocationError(error);
      this.locationBlocked = true;
      this.showRetryButton = true;
    },
    
    // HTML5定位
    getHTML5Location() {
      return new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
          reject(new Error('浏览器不支持地理定位'));
          return;
        }
        
        navigator.geolocation.getCurrentPosition(
          position => {
            if (position.coords.accuracy > 1000) {
              reject(new Error('定位精度不足'));
            } else {
              resolve({
                lat: position.coords.latitude,
                lng: position.coords.longitude,
                accuracy: position.coords.accuracy
              });
            }
          },
          error => {
            let errorMessage;
            switch(error.code) {
              case error.PERMISSION_DENIED:
                errorMessage = '位置服务被拒绝，请检查浏览器权限设置';
                break;
              case error.POSITION_UNAVAILABLE:
                errorMessage = '暂时无法获取位置，请检查网络连接';
                break;
              case error.TIMEOUT:
                errorMessage = '定位超时，请确保GPS已开启';
                break;
              default:
                errorMessage = '未知错误';
            }
            reject(new Error(errorMessage));
          },
          {
            enableHighAccuracy: true,
            timeout: 8000,
            maximumAge: 0
          }
        );
      });
    },
    
    // 通过后端代理调用腾讯位置服务的智能硬件定位接口
    async getTencentHardwareLocation() {
      // 假设后端提供了一个API端点来处理智能硬件定位
      const apiUrl = `/location/hardware`; // 替换为您的后端API地址

      try {
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            // 如果需要认证，可以在这里添加
          },
          // 如果需要传递设备信息，可以在这里添加请求体
          // body: JSON.stringify({ macAddress: '设备MAC地址' })
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        if (data.status === 0 && data.result && data.result.location) {
          const { lat, lng } = data.result.location;
          return {
            lat: parseFloat(lat),
            lng: parseFloat(lng),
            accuracy: data.result.accuracy || 5000 // 根据API返回的精度设置
          };
        } else {
          throw new Error('智能硬件定位失败: ' + (data.message || '未知错误'));
        }
      } catch (error) {
        throw new Error('智能硬件定位失败: ' + error.message);
      }
    },
    
    // IP定位（备用方案）
    async getIPLocation() {
      return new Promise((resolve, reject) => {
        // 腾讯位置服务的IP定位API文档：https://lbs.qq.com/webApi/javascriptGL/glDoc/glDoc
        // 注意：该API通常需要后端支持，因为需要提供IP地址
        // 这里假设前端可以直接调用，但实际应用中建议通过后端代理调用

        // 示例URL（请根据腾讯位置服务的最新文档调整） https://apis.map.qq.com/ws/location/v1/ip?key=ELFBZ-JDME2-Y74UU-CQZNV-UXLI6-PVBRC
        const apiUrl = `/adminapi/config/getIp`;

        fetch(apiUrl)
          .then(response => {
            if (!response.ok) {
              throw new Error('IP定位服务不可用');
            }
            return response.json();
          })
          .then(data => {
            if (data.status === 0 && data.result && data.result.location) {
              const { lat, lng } = data.result.location;
              resolve({
                lat: parseFloat(lat),
                lng: parseFloat(lng),
                accuracy: 5000 // IP定位精度设为5km
              });
            } else {
              throw new Error('IP定位数据不完整或失败');
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    
    // 保存定位到缓存
    saveLocationToCache(location, customExpiry = null) {
      this.locationCache = {
        location: location,
        timestamp: new Date().getTime()
      };
      this.cacheExpiry = customExpiry || 30 * 60 * 1000;
    },
    
    // 检查定位缓存
    checkLocationCache() {
      if (!this.locationCache) return false;
      
      const now = new Date().getTime();
      const cacheAge = now - this.locationCache.timestamp;
      
      return cacheAge < this.cacheExpiry && 
             this.locationCache.location.accuracy <= (this.locationCache.location.method === 'IP' ? 10000 : 500);
    },
    
    // 验证位置
    validateLocation(location) {
      this.showRetryButton = false;
      if (!this.allowedLocation) {
        this.locationBlocked = false;
        return;
      }
      
      const distance = this.calculateDistance(
        location.lat,
        location.lng,
        this.allowedLocation.lat,
        this.allowedLocation.lng
      );
      
      // 根据定位方式设置不同阈值
      //const useScope = location.method === 'IP' ? 50000 : this.allowedLocation.useScope; // IP定位允许更大范围
      const useScope = this.allowedLocation.useScope;
      this.locationBlocked = distance > useScope;
      
      if (this.locationBlocked) {
        this.locationError = `您距离授权区域${Math.round(distance/1000)}公里，超出当前使用范围：${useScope}米内` ;
        this.showRetryButton = true;
      }
    },
    
    // 重试定位
    retryLocation() {
      this.isRetrying = true;
      this.locationError = '正在重新定位...';
      this.showRetryButton = false;
      
      // 清除缓存强制重新定位
      this.locationCache = null;
      
      setTimeout(() => {
        this.checkUserLocation().finally(() => {
          this.isRetrying = false;
        });
      }, 500);
    },
    
    // 获取定位错误信息
    getGeolocationError(error) {
      const errorMessages = {
        1: '位置服务被拒绝，请检查浏览器权限设置',
        2: '暂时无法获取位置，请检查网络连接',
        3: '定位超时，请确保GPS已开启',
        4: '定位服务不可用',
        5: 'IP定位服务不可用',
        default: '定位失败，请检查网络或稍后重试'
      };
      
      if (error instanceof Error) {
        const code = error.message.split('错误码:')[1];
        if (code) {
          const numericCode = parseInt(code.trim(), 10);
          return errorMessages[numericCode] || errorMessages.default;
        }
        return errorMessages.default;
      }
      
      if (error.code !== undefined) {
        return errorMessages[error.code] || errorMessages.default;
      }
      
      return error.message || errorMessages.default;
    },
    
    // 计算两点间距离（米）
    calculateDistance(lat1, lon1, lat2, lon2) {
      const R = 6371e3; // 地球半径（米）
      const φ1 = lat1 * Math.PI/180;
      const φ2 = lat2 * Math.PI/180;
      const Δφ = (lat2-lat1) * Math.PI/180;
      const Δλ = (lon2-lon1) * Math.PI/180;

      const a = Math.sin(Δφ/2) * Math.sin(Δφ/2) +
                Math.cos(φ1) * Math.cos(φ2) *
                Math.sin(Δλ/2) * Math.sin(Δλ/2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));

      return R * c;
    },
    
    // 设置网站图标
    setFavicon(url) {
      let favicon = document.querySelector('link[rel="icon"]');
      if (favicon) {
        favicon.href = url;
      } else {
        favicon = document.createElement('link');
        favicon.rel = 'icon';
        favicon.href = url;
        document.head.appendChild(favicon);
      }
    },
    
    // 保持原有方法不变
    handleTouchStart(event) {
      this.touchStartX = event.touches[0].clientX;
      this.touchStartY = event.touches[0].clientY;
    },
    handleTouchEnd(event) {
      this.touchEndX = event.changedTouches[0].clientX;
      this.touchEndY = event.changedTouches[0].clientY;
      this.checkSwipeDirection();
    },
    checkSwipeDirection() {
      const minSwipeDistance = 50;
      const maxSwipeAngle = 30;
      const startXThreshold = 50;

      const distanceX = this.touchEndX - this.touchStartX;
      const distanceY = Math.abs(this.touchEndY - this.touchStartY);
      const angle = Math.atan2(distanceY, Math.abs(distanceX)) * (180 / Math.PI);

      if (distanceX > minSwipeDistance && angle < maxSwipeAngle && this.touchStartX < startXThreshold) {
        this.$router.go(-1);
      }
    },
    handleSelect(key) {
      this.activeIndex = key;
    },
    updateActiveIndex() {
      const path = this.$route.path;
      if (path.includes('/student')) {
        this.activeIndex = '1';
      } else if (path.includes('/table')) {
        this.activeIndex = '2';
      } else if (path.includes('/home') || path.includes('/mystudents')) {
        this.activeIndex = '3';
      } else {
        this.activeIndex = '1';
      }
    }
  },
  computed: {
    isHome() {
      return this.$route.path === '/';
    }
  },
  watch: {
    $route() {
      this.updateActiveIndex();
    }
  },
  created() {
    this.updateActiveIndex();
    this.appStore = useAppStore();
  }
}
</script>

<style>
/* 样式部分保持不变 */
.location-blocker {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.95);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.blocker-content {
  text-align: center;
  padding: 30px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  max-width: 80%;
}

.blocker-content i {
  font-size: 50px;
  color: #F56C6C;
  margin-bottom: 20px;
}

.blocker-content p {
  font-size: 18px;
  color: #606266;
  margin: 0 0 20px 0;
  line-height: 1.6;
}

.location-loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.9);
  z-index: 9998;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.loading-content {
  text-align: center;
  padding: 30px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  max-width: 80%;
}

.loading-content i {
  font-size: 50px;
  color: #409EFF;
  animation: rotating 2s linear infinite;
}

@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>


// WEBPACK FOOTER //
// src/App.vue